// extracted by css-extract-rspack-plugin
export default {"container":"container-V8ZoFk","noTopBorder":"noTopBorder-aRTdpB"};